import colors from '@sportninja/common/constants/appColors'
import React from 'react'

// More icon component with custom SVG
export const MoreIcon: React.FC<{ color?: string }> = ({
  color = colors.PRIMARY,
}: {
  color?: string
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
  >
    <g clipPath='url(#clip0_10717_297)'>
      <path
        d='M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z'
        fill={color}
      />
    </g>
    <defs>
      <clipPath id='clip0_10717_297'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
